import * as types from './types'

export const getLoanMerges = (payload: any) => ({
  type: types.GET_LOAN_MERGES,
  payload,
})

export const addLoanMerge = (payload: any) => ({
  type: types.ADD_LOAN_MERGE,
  payload,
})

export const editLoanMerge = (payload: any) => ({
  type: types.EDIT_LOAN_MERGE,
  payload,
})

export const submitLoanMerge = (payload: any) => ({
  type: types.SUBMIT_LOAN_MERGE,
  payload,
})

export const approveLoanMerge = (payload: any) => ({
  type: types.APPROVE_LOAN_MERGE,
  payload,
})

export const rejectLoanMerge = (payload: any) => ({
  type: types.REJECT_LOAN_MERGE,
  payload,
})

export const deleteLoanMerge = (payload: any) => ({
  type: types.DELETE_LOAN_MERGE,
  payload,
})

export const startLoadingLoanMerge = () => ({
  type: types.START_LOADING_LOAN_MERGE,
  payload: null,
})

export const stopLoadingLoanMerge = () => ({
  type: types.STOP_LOADING_LOAN_MERGE,
  payload: null,
})